import React from 'react';
import '../CSS/style/style.css';

const seasons = [
    { label: '주중',    desc: '일 ~ 금요일',          color: '#4caf50' },
    { label: '주말',    desc: '토요일 및 공휴일 전날', color: '#2196f3' },
    { label: '준성수기', desc: '6월 / 9월',            color: '#ff9800' },
    { label: '성수기',  desc: '7월 / 8월',             color: '#f44336' },
    { label: '극성수기', desc: '7/25 ~ 8/8 및 7,8월 주말',  color: '#9c27b0' },
];

const rooms = [
    { room: '단풍',  standard: '2인 기준', price: ['80,000','120,000','120,000','180,000','180,000','250,000','250,000'] },
    { room: '보리수', standard: '2인 기준', price: ['80,000','120,000','120,000','180,000','180,000','250,000','250,000'] },
    { room: '이팝',  standard: '4인 기준', price: ['130,000','170,000','170,000','220,000','220,000','300,000','300,000'] },
    { room: '소나무', standard: '4인 기준', price: ['130,000','170,000','170,000','220,000','220,000','300,000','300,000'] },
    { room: '느릅',  standard: '6인 기준', price: ['180,000','220,000','220,000','300,000','300,000','380,000','380,000'] },
    { room: '자귀',  standard: '8인 기준', price: ['350,000','420,000','350,000','420,000','420,000','550,000','550,000'] },
];

const extraFees = [
    { icon: '🌿', title: '평상 (평일)', desc: '4인 기준 50,000원\n추가 1인당 10,000원' },
    { icon: '🌿', title: '평상 (주말)\n 극성수기 포함', desc: '3인 이하 50,000원\n4인 60,000원 / 추가 1인 10,000원\n10~13인 150,000원\n14~18인 200,000원\n19~23인 250,000원' },
    { icon: '🔥', title: '숯불 요금',   head: '숯+그릴+석쇠 제공', desc: '2~4인 20,000원\n5~7인 30,000원\n8~10인 40,000원\n10인 이상 50,000원', foot: '숯 추가 10,000원~' },
    { icon: '🏕️', title: '오토캠핑',   desc: '60,000원~' },
    { icon: '🚗', title: '픽업 (편도)', desc: '포항역 50,000원\n포항버스터미널 60,000원' },
];

const cautions = [
    {
        title: '◎ 입·퇴실 안내',
        items: ['입실: 오후 3시 이후', '퇴실: 오전 11시 이전', '청소 시간 확보를 위해 시간 엄수 부탁드립니다.'],
    },
    {
        title: '◎ 객실 이용 안내',
        items: ['모든 객실은 금연입니다. 흡연은 외부 지정 장소를 이용해 주세요.', '인원 초과 및 무단 입실은 제한됩니다. (추가요금 발생 또는 퇴실 조치)', '반려동물 동반 입실은 불가합니다.'],
    },
    {
        title: '◎ 펜션 내 에티켓',
        items: ['밤 10시 이후 실외 활동 및 소음 자제 부탁드립니다.', '객실 내 고기/생선 굽기, 기름 사용 요리 금지 (야외 바비큐장 이용)', '가구 및 집기류 파손 시 변상 비용이 청구될 수 있습니다.'],
    },
    {
        title: '◎ 바비큐장 이용',
        items: ['이용 시간: 오후 5시 ~ 밤 8시', '그릴·숯 제공은 사전 예약 필수 (별도 요금)', '날씨에 따라 운영이 제한될 수 있습니다.'],
    },
    {
        title: '◎ 화재 및 안전',
        items: ['불꽃놀이, 폭죽, 촛불 사용 금지', '개인 화로 및 장작 사용 금지', '화기 사용 시 안전수칙 준수 부탁드립니다.'],
    },
    {
        title: '◎ 퇴실 시 협조사항',
        items: ['사용한 식기류는 세척 후 정리 부탁드립니다.', '쓰레기는 분리수거하여 지정 장소에 버려주세요.', '퇴실 전 조명·냉난방기기 전원 OFF 확인 바랍니다.'],
    },
];

const Reservation = () => {
    return (
        <div className="main-wrapper">
            <section className="foot-banner"></section>

            <div className="reservation-container">

                {/* ── 예약 안내 ── */}
                <div className="section-header">
                    <span className="section-label">RESERVATION</span>
                    <h2 className="section-title">예약 안내</h2>
                    <p className="section-desc">자연과 함께하는 편안한 휴식, 물조은펜션을 찾아주셔서 감사합니다.<br/>아래 안내 사항을 확인하신 후 예약해 주세요.</p>
                </div>

                <div className="res-info-cards">
                    <div className="res-info-card">
                        <span className="res-info-icon">📅</span>
                        <h3 className="res-info-title">예약 방법</h3>
                        <p>예약은 <strong>전화예약</strong>으로만 가능합니다.</p>
                        <p className="res-phone">010-2180-7979<br/>010-7447-9222</p>
                        <p>예약 전 객실 정보와 요금표를 꼭 확인해주세요.</p>
                    </div>
                    <div className="res-info-card">
                        <span className="res-info-icon">💳</span>
                        <h3 className="res-info-title">입금 안내</h3>
                        <p>예약 후 <strong>2시간 이내</strong> 입금 시 예약이 확정됩니다.</p>
                        <p>(당일·하루 전 예약은 <strong>1시간 이내</strong> 입금)</p>
                        <p>입금 후 입금자 성함을 <strong>문자</strong>로 꼭 보내주세요.</p>
                        <p>입금자명이 예약자명과 다를 경우 미리 알려주세요.</p>
                    </div>
                    <div className="res-info-card res-info-card--accent">
                        <span className="res-info-icon">🏦</span>
                        <h3 className="res-info-title">입금 계좌</h3>
                        <div className="res-account-box">
                            <p className="res-account-bank">농협은행</p>
                            <p className="res-account-number">717096-52-18-6664</p>
                            <p className="res-account-name">예금주: 윤정아</p>
                        </div>
                    </div>
                </div>

                <div className="main-divider"><span></span></div>

                {/* ── 요금 안내 ── */}
                <div className="section-header">
                    <span className="section-label">PRICING</span>
                    <h2 className="section-title">요금 안내</h2>
                    <p className="section-desc">인원 추가: 성인 20,000원 / 아동(만7세~) 20,000원 / 미취학아동 무료</p>
                </div>

                <div className="res-season-tags">
                    {seasons.map(({ label, desc, color }) => (
                        <div key={label} className="res-season-tag" style={{ borderColor: color }}>
                            <span className="res-season-name" style={{ background: color }}>{label}</span>
                            <span className="res-season-desc">{desc}</span>
                        </div>
                    ))}
                </div>

                {/* 데스크톱: 테이블 */}
                <div className="res-table-wrap room-price-wrap">
                    <table className="refund-table room-price-table">
                        <thead>
                        <tr>
                            <td rowSpan={2}>객실<br/>(기준인원)</td>
                            <td rowSpan={2}>특징</td>
                            <td colSpan={2}>비수기</td>
                            <td colSpan={2}>준성수기<br/><span>(6월/9월)</span></td>
                            <td>성수기<br/><span>(7월/8월 주중)</span></td>
                            <td rowSpan={2}>극성수기<br/><span>(7/25~8/8<br/>7,8월 주말)</span></td>
                        </tr>
                        <tr style={{ backgroundColor: '#eee' }}>
                            <td>주중</td>
                            <td>주말</td>
                            <td>주중</td>
                            <td>주말</td>
                            <td>주중</td>
                        </tr>
                        </thead>
                        <tbody>
                        {rooms.map(({ room, standard, price }) => (
                            <tr key={room}>
                                <td>{room}<br/><span className="res-standard">({standard})</span></td>
                                <td>온돌방+침대</td>
                                <td>{price[0]}원</td>
                                <td>{price[1]}원</td>
                                <td>{price[2]}원</td>
                                <td>{price[3]}원</td>
                                <td>{price[4]}원</td>
                                <td>{price[6]}원</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

                {/* 모바일: 방별 카드 */}
                <div className="room-mobile-cards">
                    {rooms.map(({ room, standard, price }) => (
                        <div key={room} className="room-mobile-card">
                            <div className="room-mobile-header">
                                <div className="room-mobile-name-wrap">
                                    <span className="room-mobile-name">{room}</span>
                                    <span className="room-mobile-standard">{standard}</span>
                                </div>
                                <span className="room-mobile-feature">온돌방+침대</span>
                            </div>
                            <div className="room-mobile-price-list">
                                {[
                                    { season: '비수기',   color: '#4caf50', bg: '#f0f9ee', weekday: price[0], weekend: price[1] },
                                    { season: '준성수기', color: '#e65100', bg: '#fff3e0', weekday: price[2], weekend: price[3] },
                                    { season: '성수기',   color: '#c62828', bg: '#fce4ec', weekday: price[4] },
                                    { season: '극성수기', color: '#6a1b9a', bg: '#f3e5f5', single: price[6] },
                                ].map(({ season, color, bg, weekday, weekend, single }) => (
                                    <div key={season} className="room-mobile-price-row">
                                        <span className="room-mobile-season-badge" style={{ color, background: bg }}>{season}</span>
                                        <div className="room-mobile-price-values">
                                            {single ? (
                                                <span className="room-mobile-price-single">{single}원</span>
                                            ) : (
                                                <>
                                                    <span className="room-mobile-price-item"><em>주중</em>{weekday}원</span>
                                                    {weekend && <span className="room-mobile-price-item"><em>주말</em>{weekend}원</span>}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="res-extra-cards">
                    {extraFees.map(({ icon, title, head, desc, foot }) => (
                        <div key={title} className="res-extra-card">
                            <span className="res-extra-icon">{icon}</span>
                            <p className="res-extra-title">{title}</p>
                            {head && <p className="res-extra-note">{head}</p>}
                            <p className="res-extra-desc">{desc}</p>
                            {foot && <p className="res-extra-note">{foot}</p>}
                        </div>
                    ))}
                </div>

                <div className="main-divider"><span></span></div>

                {/* ── 주의사항 ── */}
                <div className="section-header">
                    <span className="section-label">NOTICE</span>
                    <h2 className="section-title">주의사항</h2>
                </div>

                <div className="res-caution-grid">
                    {cautions.map(({ title, items }) => (
                        <div key={title} className="res-caution-card">
                            <h3 className="res-caution-title">{title}</h3>
                            <ul className="res-caution-list">
                                {items.map((item, i) => <li key={i}>{item}</li>)}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="res-closing">
                    편안하고 즐거운 여행이 되실 수 있도록 언제나 최선을 다하겠습니다. 감사합니다.
                </div>

                <div className="main-divider"><span></span></div>

                {/* ── 취소·환불 ── */}
                <div className="section-header">
                    <span className="section-label">REFUND</span>
                    <h2 className="section-title">취소 및 환불 안내</h2>
                    <p className="section-desc">예약 취소 시 아래 환불 규정에 따릅니다.</p>
                </div>

                {/* 데스크톱: 테이블 */}
                <div className="res-table-wrap refund-table-wrap">
                    <table className="refund-table">
                        <thead>
                        <tr>
                            <td>입금 후<br/>24시간 이내</td>
                            <td>24시간~<br/>9일전</td>
                            <td>8일전</td>
                            <td>7일전</td>
                            <td>6일전</td>
                            <td>5일전</td>
                            <td>4일전</td>
                            <td>3일전</td>
                            <td>2일전</td>
                            <td>1일전</td>
                            <td>당일</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            {['100%','90%','80%','70%','60%','50%','40%','30%','20%','10%','0%'].map((v, i) => (
                                <td key={i}>{v} 환불</td>
                            ))}
                        </tr>
                        </tbody>
                    </table>
                </div>

                {/* 모바일: 카드 */}
                <div className="refund-mobile-card">
                    {[
                        { label: '입금 후 24시간 이내', rate: 100, color: '#2e7d32', bg: '#e8f5e9' },
                        { label: '24시간 ~ 9일 전',     rate: 90,  color: '#388e3c', bg: '#f1f8e9' },
                        { label: '8일 전',               rate: 80,  color: '#558b2f', bg: '#f9fbe7' },
                        { label: '7일 전',               rate: 70,  color: '#827717', bg: '#fffde7' },
                        { label: '6일 전',               rate: 60,  color: '#f57f17', bg: '#fff8e1' },
                        { label: '5일 전',               rate: 50,  color: '#e65100', bg: '#fff3e0' },
                        { label: '4일 전',               rate: 40,  color: '#bf360c', bg: '#fbe9e7' },
                        { label: '3일 전',               rate: 30,  color: '#c62828', bg: '#fce4ec' },
                        { label: '2일 전',               rate: 20,  color: '#ad1457', bg: '#fce4ec' },
                        { label: '1일 전',               rate: 10,  color: '#b71c1c', bg: '#ffebee' },
                        { label: '당일',                 rate: 0,   color: '#fff',    bg: '#c62828' },
                    ].map(({ label, rate, color, bg }) => (
                        <div key={label} className="refund-mobile-row">
                            <span className="refund-mobile-label">{label}</span>
                            <span className="refund-mobile-badge" style={{ color, background: bg }}>
                                {rate}% 환불
                            </span>
                        </div>
                    ))}
                </div>

                <div className="res-refund-notice">
                    <p>• 일반적인 우천 시에는 기존 예약 취소 규정에 따라 취소 수수료가 부과됩니다.</p>
                    <p>• 단순 비 소식이나 흐린 날씨는 환불 사유에 해당하지 않습니다.</p>
                    <p>• 펜션 앞 다리가 침수되어 차량 진입이 불가능한 경우 현장 확인 후 <strong>100% 환불</strong>해 드립니다.</p>
                    <p className="res-refund-closing">기상 상황이 우려될 경우 미리 연락 주시면 친절히 안내드리겠습니다. 안전하고 편안한 여행이 되시길 바랍니다.</p>
                </div>

            </div>
        </div>
    );
};

export default Reservation;
